<div #container #trigger="cdkOverlayOrigin" cdkOverlayOrigin>
    <ng-content />
</div>

@if (noOverlay()) {
    @if (open()) {
        <ng-container *ngTemplateOutlet="content" />
    }
} @else if (isBrowser) {
    <ng-template
        [cdkConnectedOverlayOrigin]="trigger"
        [cdkConnectedOverlayOpen]="open()"
        [cdkConnectedOverlayOffsetY]="-2"
        [cdkConnectedOverlayWidth]="container?.getBoundingClientRect()?.width ?? 0"
        [cdkConnectedOverlayMinWidth]="container?.getBoundingClientRect()?.width ?? 0"
        [cdkConnectedOverlayScrollStrategy]="scroll"
        (overlayOutsideClick)="open.set(false)"
        (detach)="open.set(false)"
        cdkConnectedOverlay
    >
        <ng-container *ngTemplateOutlet="content" />
    </ng-template>
}

<ng-template #content>
    <div
        class="custom-scrollbar-grey max-h-[200px] w-full overflow-auto border-2 border-t-0"
        @slideUpDown
        [ngClass]="{
            'border-grey-400 bg-white text-black': theme() === 'light' || theme() === 'dark',
            'bg-accent border-white text-white': theme() === 'medium',
        }"
    >
        <ng-content select="[dropdown]" />
    </div>
</ng-template>
